import { Box, Button, Input, useToast } from "@chakra-ui/react";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAPI } from "../api/useAPI";
import { useAPIQuery } from "../api/useAPIQuery";
import { useOnAPISuccess } from "../api/useOnAPISuccess";
import { useToastOnAPIError } from "../api/useToastOnAPIError";
import { LOGGED_IN_HOME_PAGE } from "../config";
import { Logo } from "../utils/Logo";
import { THEME_COLOR_SCHEME } from "../utils/theme";

export const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const api = useAPI();
  const toast = useToast();
  const { data, state, error, query } = useAPIQuery<"authLogin">({
    apiCall: api.authLogin,
  });
  const navigate = useNavigate();
  useToastOnAPIError({ title: "Unable to log in", error });
  useOnAPISuccess<"authLogin">({
    data,
    state,
    onSuccess: () => {
      navigate(LOGGED_IN_HOME_PAGE);
    },
  });

  const onLogin = useCallback(() => {
    if (email.length === 0) {
      toast({
        status: "error",
        title: "Invalid email",
        description: "Email length cannot be empty",
        position: "top",
      });
      return;
    }

    if (password.length === 0) {
      toast({
        status: "error",
        title: "Invalid password",
        description: "Password length cannot be empty",
        position: "top",
      });
      return;
    }

    query({ email, password });
  }, [email, password, query, toast]);

  return (
    <Box
      className="fullHeight"
      top={0}
      left={0}
      position={"fixed"}
      width={"100%"}
      display={"flex"}
      flexDir={"column"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Box
        padding={4}
        maxWidth={"400px"}
        width={"100%"}
        display={"flex"}
        flexDir={"column"}
        alignItems={"center"}
      >
        <Logo marginBottom={8} />
        <Input
          placeholder="email"
          marginBottom={4}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Input
          placeholder="password"
          type={"password"}
          marginBottom={4}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button
          isLoading={state === "loading"}
          colorScheme={THEME_COLOR_SCHEME}
          onClick={onLogin}
          width={"100%"}
          size={"lg"}
        >
          Login
        </Button>
      </Box>
    </Box>
  );
};
